import { Box } from "@mui/material";

const HeaderTopLinks: React.FC = () => {
  return (
    <Box display={"flex"} alignItems={"center"} justifyContent={"space-between"} py={2} mr={5} ml={5}>
      <p className="headerNewsletter">
        Fique por dentro das novidades, inscreva-se em nossa{" "}
        <a href="https://www.kappa.com.br/" target="_blank" style={{ color: "#000" }}>
          Newsletter
        </a>
      </p>
      {/* social */}
      <div style={{ display: "flex", gap: 30, alignItems: "center" }}>
        <a href="https://www.instagram.com/kappa/" target="_blank">
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M21.948.941H10.654a9.29 9.29 0 0 0-9.336 9.337v11.294a9.286 9.286 0 0 0 9.336 9.336h11.294a9.28 9.28 0 0 0 9.336-9.336V10.278A9.384 9.384 0 0 0 21.948.941m6.475 20.781a6.68 6.68 0 0 1-6.626 6.626H10.503a6.68 6.68 0 0 1-6.626-6.626V10.278a6.68 6.68 0 0 1 6.626-6.626h11.294a6.68 6.68 0 0 1 6.626 6.626z"
              fill="#21222D"
            />
            <path
              d="M16.226 8.471A7.529 7.529 0 1 0 23.755 16a7.454 7.454 0 0 0-7.529-7.529m0 12.198A4.668 4.668 0 1 1 20.894 16a4.687 4.687 0 0 1-4.668 4.668m8.132-11.746a1.054 1.054 0 1 0 0-2.108 1.054 1.054 0 0 0 0 2.108"
              fill="#21222D"
            />
          </svg>
        </a>
        <a href="https://www.facebook.com/kappa.brasil" target="_blank">
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M16 .941a15.07 15.07 0 0 0-2.259 29.967V20.367H9.826V16h3.765v-3.313a5.186 5.186 0 0 1 5.572-5.722c1.111.013 2.221.113 3.313.301v3.614h-1.807a2.165 2.165 0 0 0-2.409 2.259V16h4.066l-.602 4.367h-3.465v10.541A15.07 15.07 0 0 0 16 .941"
              fill="#21222D"
            />
          </svg>
        </a>
        <a href="https://www.youtube.com/channel/UCPbkdddkt95QtHi1OuiVmDg" target="_blank">
          <svg width="32" height="26.353" viewBox="0 0 32 26.353" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M31.059 13.269a35.8 35.8 0 0 0-.753-7.981 4.2 4.2 0 0 0-2.861-2.861C24.885 1.674 16 1.674 16 1.674s-8.885 0-11.445.753a4.2 4.2 0 0 0-2.861 2.861 46 46 0 0 0-.753 7.981 35.8 35.8 0 0 0 .753 7.981 4.2 4.2 0 0 0 2.861 2.861c2.56.753 11.445.753 11.445.753s8.885 0 11.445-.753a4.2 4.2 0 0 0 2.861-2.861 35.7 35.7 0 0 0 .753-7.981m-18.372 4.819V8.45l8.584 4.819z"
              fill="#21222D"
            />
          </svg>
        </a>
        <a href="https://www.tiktok.com/@kappa_official">
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M16 .941A15.059 15.059 0 1 0 31.059 16 15.1 15.1 0 0 0 16 .941m9.035 13.101h-.452a5.37 5.37 0 0 1-4.668-2.56v8.734a6.52 6.52 0 0 1-6.475 6.475 6.654 6.654 0 0 1-6.475-6.626 6.426 6.426 0 0 1 6.475-6.475h.452v3.163h-.452a3.313 3.313 0 1 0 3.464 3.464V5.459h3.012a5.485 5.485 0 0 0 5.12 4.969z"
              fill="#21222D"
            />
          </svg>
        </a>
      </div>
      {/* social */}
    </Box>
  );
};
export default HeaderTopLinks;
